import type { ProgramOutcome } from '@@/api/program';

/**
 * One wording and one colour per outcome, read by the tiles, the chart and the list,
 * so a "mixed" test is the same amber everywhere on the page.
 *
 * Mixed is warn rather than ok: a winner beside a loser is a comparison someone still
 * has to read, which is the same meaning warn carries on Health.
 */
/** What the screen shows. No-data tests are left out of it (see summariseProgram). */
export const OUTCOME_ORDER: readonly ProgramOutcome[] = ['won', 'mixed', 'lost', 'inconclusive'];

export const OUTCOME_LABEL: Record<ProgramOutcome, string> = {
  won: 'Won',
  lost: 'Lost',
  mixed: 'Mixed',
  inconclusive: 'Inconclusive',
  'no-data': 'No data',
};

export const OUTCOME_TEXT: Record<ProgramOutcome, string> = {
  won: 'text-ok',
  lost: 'text-danger',
  mixed: 'text-warn',
  inconclusive: 'text-dim',
  'no-data': 'text-dim',
};

export const OUTCOME_FILL: Record<ProgramOutcome, string> = {
  won: 'hsl(var(--ok))',
  lost: 'hsl(var(--danger))',
  mixed: 'hsl(var(--warn))',
  inconclusive: 'hsl(var(--dim))',
  'no-data': 'hsl(var(--barMuted))',
};

/** Signed, one decimal; a dash for nothing, never a misleading zero. */
export const formatLift = (lift: number | null): string =>
  lift === null ? '—' : `${lift > 0 ? '+' : ''}${lift.toFixed(1)}%`;

export const formatRate = (rate: number | null): string => (rate === null ? '—' : `${Math.round(rate)}%`);

export const formatDays = (days: number | null): string => (days === null ? '—' : `${Math.round(days)}d`);
